import React from 'react';

export default class Label extends React.Component {

  style = {  
    label:
      {
        userSelect: "none",
        lineHeight: "32px",
        fontSize: 12,
        color: "rgba(0, 0, 0, 0.298039)"
      }
  }

    
  render = () => 
    <label style={this.style.label}>{this.props.children}</label>
  
}



// WEBPACK FOOTER //
// ./src/components/Form/Label.jsx